import VButton from './Button.vue';
import VCheckbox from './Checkbox.vue';
import VInput from './Input.vue';
import VLabel from './Label.vue';
import VListItem from './ListItem.vue';
import VLoadingSpinner from './LoadingSpinner.vue';
import VMessage from './Message.vue';
import VTab from './Tab.vue';

const components = {
  VButton,
  VCheckbox,
  VInput,
  VLabel,
  VListItem,
  VLoadingSpinner,
  VMessage,
  VTab,
};

export default {
  install(Vue) {
    Object.keys(components).forEach((name) => {
      Vue.component(name, components[name]);
    });
  },
};

export {
  VButton,
  VCheckbox,
  VInput,
  VLabel,
  VListItem,
  VLoadingSpinner,
  VMessage,
  VTab,
};
